import { GridApi, GridOptions, IServerSideDatasource, IServerSideGetRowsParams } from '@ag-grid-community/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FinancialsStatusBarComponent } from 'src/app/ag-grid-components/fbm-order-tool-panel/financials-status-bar/financials-status-bar.component';
import { LoadingCellRendererComponent } from 'src/app/ag-grid-components/loading-cell-renderer/loading-cell-renderer.component';
import { Order } from 'src/app/models/fbmOrders.model';
import { FbmOrdersService } from 'src/app/modules/fbm-orders/fbm-orders.service';

@Component({
  selector: 'app-fbm-financials-details',
  templateUrl: './fbm-financials-details.component.html',
  styleUrls: ['./fbm-financials-details.component.scss']
})
export class FbmFinancialsDetailsComponent implements OnInit, OnDestroy {

  gridApi: GridApi;
  destroy: Subject<void> = new Subject<void>();
  constructor(private fbmOrderService: FbmOrdersService) { }

  ngOnInit(): void {
  }

  private _order: Order;
  @Input() get order(): Order {
    return this._order;
  }

  set order(value: Order) {
    this._order = value;
    if (value) {
      this.gridApi?.setGridOption("serverSideDatasource", this.dataSource);
    }
  }

  private components = {
    loadingCellRenderer: LoadingCellRendererComponent,
    financialsStatusBarComponent: FinancialsStatusBarComponent
  };

  columnDefs = [
    {
      field: "sku",
      headerName: "Sku",
      maxWidth: 130,
      tooltipField: "sku"
    },
    {
      field: "amountType",
      headerName: "Type",
      maxWidth: 80,
      tooltipField: "amountType"
    },
    {
      field: "amountType",
      headerName: "Description",
      maxWidth: 130,
      tooltipField: "amountType"
    },
    {
      field: "amount",
      headerName: "Amount",
      maxWidth: 60,
      valueFormatter: (param) =>
          param.value ? "$" + (parseFloat(Number(param.value).toFixed(2))).toLocaleString('en') : '$0.00',
    }
  ];

  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    blockLoadDebounceMillis: 1,
    suppressCopyRowsToClipboard: true,
    defaultColDef: {
      menuTabs: ["filterMenuTab"],
      resizable: true,
      sortable:false
    },
    components: this.components,
    rowHeight: 30,
    headerHeight: 30,
    loadingCellRenderer: "loadingCellRenderer",
    cacheBlockSize: 100,
    pivotPanelShow: "onlyWhenPivoting",
    rowBuffer: 50,
    statusBar: {
      statusPanels: [
        { statusPanel: "financialsStatusBarComponent", align: "left" },
      ],
    },
    enableCellChangeFlash: true,
    onGridReady: (e) => {
      this.gridApi = e.api;
      this.gridApi.setGridOption("serverSideDatasource", this.dataSource);
      this.gridApi.sizeColumnsToFit();
    }
  };

  dataSource: IServerSideDatasource = {
    getRows: (params: IServerSideGetRowsParams) => {
      this.fbmOrderService
        .getFinancialDetails(this.order?.Orderid ? this.order?.Orderid : this.order?.orderId)
        .pipe(takeUntil(this.destroy))
        .subscribe((response: any) => {
          if (response && response.length == 0) {
            this.gridApi.showNoRowsOverlay();
          } else {
            this.gridApi.hideOverlay();
          }
          params.success({
            rowData: response,
            rowCount: response?.length ?? 0
          });
        });
    },
  };

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.unsubscribe();
  }
}
